module.exports = "/static/assets/c430d35ee228bc8ecba3e8b87b311b5e.png";